<template>
  <div class="signup-form form">
    <div class="field">
      <label for="first-name" class="label">Primeiro Nome *</label>
      <div class="control">
        <input
          id="first-name"
          type="text"
          class="input"
          v-model="fData.firstName"
          :disabled="disabledFields.firstName"
        >
      </div>
    </div>
    <div class="field">
      <label for="last-name" class="label">Último Nome *</label>
      <div class="control">
        <input
          id="last-name"
          type="text"
          class="input"
          v-model="fData.lastName"
          :disabled="disabledFields.lastName"
        >
      </div>
    </div>
    <div class="field">
      <label for="email" class="label">Email *</label>
      <div class="control">
        <input
          id="email"
          type="email"
          class="input"
          v-model="fData.email"
          :disabled="disabledFields.email"
        >
      </div>
    </div>
    <div class="field">
      <ComparePwds
        :required="true"
        :min="6"
        v-model="fData.password"
        :disabled="disabledFields.password"
      />
    </div>
    <div class="field">
      <button
        class="button is-primary"
        :class="{ 'is-loading': isLoading }"
        :disabled="isDisabled || $v.fData.$invalid"
        @click="onSubmit(fData)"
      >
        {{ButtonLabel || 'Cadastrar'}}
      </button>
    </div>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import FormMixin from './FormMixin'
import ComparePwds from '../ComparePwds'

export default {
  name: 'signupForm',
  mixins: [FormMixin],
  components: { ComparePwds },
  validations: {
    fData: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      email: {
        required,
        email
      },
      password: {
        required
      }
    }
  },
  data () {
    return {
      fData: {
        firstName: '',
        lastName: '',
        email: '',
        password: ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/SignupForm.vue